module.exports = __webpack_public_path__ + "img/coin_100.223d1f45.png";